import React from "react";
import PropTypes from "prop-types";
import { useNotificationContext } from "libs/context/NotificationContext";

const LiveNotificationCard = ({ notification, onDismiss, index = 0 }) => {
  return (
    <div
      className="live-notification-card"
      style={{ "--live-notif-delay": `${index * 0.08}s` }}
      role="alert"
    >
      <div className="live-notification-card__icon-panel">
        <i className="fa fa-bell" />
      </div>

      <div className="live-notification-card__content-panel">
        <button
          type="button"
          className="live-notification-card__close"
          aria-label="Dismiss notification"
          onClick={() => onDismiss(notification.id)}
        >
          <i className="fa fa-times" />
        </button>

        <h6 className="live-notification-card__title">
          {notification?.title || "Notification"}
        </h6>
        {notification?.message ? (
          <p className="live-notification-card__message">
            {notification.message}
          </p>
        ) : null}
      </div>
    </div>
  );
};

LiveNotificationCard.propTypes = {
  notification: PropTypes.object.isRequired,
  onDismiss: PropTypes.func.isRequired,
  index: PropTypes.number,
};

const LiveNotificationAlert = () => {
  const { liveAlerts, dismissLiveAlert } = useNotificationContext() || {};

  if (!liveAlerts?.length) {
    return null;
  }

  return (
    <div className="live-notification-stack" aria-live="polite">
      {liveAlerts.map((notification, index) => (
        <LiveNotificationCard
          key={notification.id}
          notification={notification}
          onDismiss={dismissLiveAlert}
          index={index}
        />
      ))}
    </div>
  );
};

export default LiveNotificationAlert;
